<template>
  <div class="podsklop" :class="{ sklopiva, otvoreno: ot }">
    <div class="podnaslov" @click="sklopiva && prebaci()">
      {{ naslov }}
      <span v-if="dodatak" class="dodatak">{{ dodatak }}</span>
      <span v-if="kljucevi.length && sklopiva" class="dodatak">{{ popunjeno }} od {{ kljucevi.length }}</span>
      <span v-if="gresaka" class="mali-znak">{{ gresaka }}</span>
      <span v-if="sklopiva" class="strelica">▾</span>
    </div>
    <div class="sadrzaj"><slot></slot></div>
  </div>
</template>

<script>
import { brojPopunjenih } from './formaLogika'

// Podskupina (podnaslov) unutar kartice; kad je sklopiva, rijetko popunjeni redovi stoje sklopljeni.
export default {
  name: 'FormaPodskupina',
  inject: { okvir: { default: null } },
  props: {
    naslov: { type: String, default: '' },
    dodatak: { type: String, default: '' },
    sklopiva: { type: Boolean, default: false },
    otvoreno: { type: Boolean, default: true },
    kljucevi: { type: Array, default: () => [] },
    model: { type: Object, default: () => ({}) }
  },
  data () { return { ot: this.otvoreno } },
  computed: {
    popunjeno () { return brojPopunjenih(this.model, this.kljucevi) },
    gresaka () { return this.okvir ? this.kljucevi.filter(k => this.okvir.greske[k]).length : 0 }
  },
  watch: {
    otvoreno (v) { this.ot = v },
    gresaka (n) { if (n > 0) this.otvori() }
  },
  created () { if (this.okvir) this.okvir.registriraj(this) },
  beforeDestroy () { if (this.okvir) this.okvir.odjavi(this) },
  methods: {
    prebaci () { this.postavi(!this.ot) },
    otvori () { this.postavi(true) },
    postavi (v) {
      this.ot = v
      this.$emit('update:otvoreno', v)
    }
  }
}
</script>
